/**
 * What an empty folder says (#721 audit R4).
 *
 * The unified surface answered every empty view, whichever the folder, with
 * "This inbox is quiet" — which is true of the Inbox and wrong in Archived,
 * where an empty list is a statement about Archived, not about the whole inbox.
 *
 * Keyed by the rail's view id (`services/mail_folders.py::FOLDER_VIEWS`). The
 * Inbox has no entry on purpose: its caller keeps the wording it already had.
 */
const COPY = {
    starred: { title: 'Nothing starred', body: 'Star a conversation to keep it within reach.' },
    important: { title: 'Nothing marked important' },
    snoozed: {
        title: 'Nothing snoozed',
        body: 'Snoozed conversations return to your Inbox when their time comes.',
    },
    sent: { title: 'No sent mail' },
    drafts: { title: 'No drafts' },
    scheduled: { title: 'Nothing scheduled' },
    archived: {
        title: 'Nothing archived',
        body: 'Archived conversations are kept here, out of your Inbox.',
    },
    spam: { title: 'No spam' },
    trash: { title: 'Trash is empty' },
    all: { title: 'No mail yet' },
    social: { title: 'Nothing in this category' },
    updates: { title: 'Nothing in this category' },
    promotions: { title: 'Nothing in this category' },
};

/** `{ title, body? }` for an empty non-Inbox view, or `null` for the Inbox and unknown ids. */
export function emptyFolderCopy(folder) {
    return COPY[folder] || null;
}
